import React from "react";

const ScrollUp = () => {
    return(
        <a href="#" className="scrollup" id="scroll-up">
            <i className='bx bx-chevrons-up'></i>
        </a>
    );
}

export default ScrollUp;